export const formatRanges = (ranges) => {
  return ranges.map((range, index, arr) => {
    const [min, max] = range.split("-").map((val) => val.replace(/,/g, ""));

    let previousMax = null;
    if (index > 0) {
      const prevRange = arr[index - 1]
        .split("-")
        .map((val) => val.replace(/,/g, ""));
      previousMax = prevRange[1] ?? prevRange[0];
    }

    // Adjust min value dynamically (e.g., 101 → 100, 501 → 500, etc.)
    const adjustedMin =
      previousMax && parseInt(min) === parseInt(previousMax) + 1
        ? `${parseInt(previousMax)}`
        : min;

    // Ensure no duplicate `+` at the end
    const formattedKey = max
      ? `${adjustedMin.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}-${max.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        )}`
      : adjustedMin.endsWith("+")
      ? adjustedMin.replace(/\B(?=(\d{3})+(?!\d))/g, ",") // Avoid adding extra `+`
      : `${adjustedMin.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}+`;

    return {
      key: formattedKey,
      value: range,
    };
  });
};

export const parseDate = (dateString) => {
  if (!dateString || typeof dateString !== "string") {
    return new Date(0);
  }
  const parts = dateString.split("/").map(Number);
  if (parts.length !== 3) {
    return new Date(0);
  }
  const [day, month, year] = parts;
  return new Date(year, month - 1, day);
};

// export const formatPrice = (value) => {
//   if (value == null) return null;
//   const raw = value.toString().replace(/[£$€₪]/g, "");
//   const num = parseFloat(raw);
//   if (!isNaN(num) && isFinite(num)) {
//     return Number.isInteger(num) ? num : num.toFixed(2);
//   }
//   return null;
// };

/**
 * A money amount for display (no currency symbol): thousands separators, and
 * two decimals only when there are agorot/cents — 528 → "528",
 * 670.7 → "670.70", 1234.5 → "1,234.50". The same rule on every screen.
 */
export const formatAmount = (num) => {
  const rounded = Math.round(Number(num) * 100) / 100;
  const hasCents = !Number.isInteger(rounded);
  return rounded.toLocaleString("en-US", {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  });
};

export const formatPrice = (value) => {
  if (value == null) return null;
  const raw = value.toString().replace(/[£$€₪,\s]/g, "");
  const num = parseFloat(raw);
  if (!isNaN(num) && isFinite(num)) {
    return formatAmount(num);
  }
  return null;
};

/** Currency symbol before the number: formatMoney(670.7) → "₪670.70". */
export const formatMoney = (value, symbol = "₪") => {
  const amount = formatPrice(value);
  return amount == null ? null : `${symbol}${amount}`;
};

/** Summary-screen percentage: a whole number, "31%". */
export const formatPercent = (value) => `${Math.round(Number(value) || 0)}%`;

/**
 * Joins address parts that the API sends pre-concatenated, dropping empty
 * ones — ", Petah Tikva, Israel" → "Petah Tikva, Israel".
 */
export const formatAddress = (address) =>
  address
    ? String(address)
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean)
        .join(", ")
    : "";

/**
 * Wraps a value in Unicode isolates (FSI…PDI) — the plain-string equivalent of
 * <bdi> — so names, numbers and links inside a sentence of the other
 * direction don't flip or break the line.
 */
export const bidiIsolate = (value) =>
  value == null || value === "" ? value : `\u2068${value}\u2069`;
